import React from 'react'
import SectionHeader from '../sectionHeader'
import SectionSubHeader from '../sectionSubHeader'
import { Col, Container, Row } from 'react-bootstrap'

const PageDescription = () => {
  return (
    <div className='about-volto volto-section pdtop'>
         <Container>
          <Row className='tab-row'>
            <Col lg={5} className='tab-none'>
               <img className='img-fluid ' src="/images/aboutVolto.webp" alt="aboutVolto" />
            </Col>
            <Col lg={7}>
              <div className='about-volto-description'>
                <SectionHeader mainText1={"About"} mainText2={"VOLTO"} />
                 <SectionSubHeader headerText={"Challenge the present. Shape the future."} />
                 <p>With 1000+ associates spread across 4 continents and a strong network of professionals, Volto is shaping the future of businesses - one meaningful partnership at a time.</p>
                 <p>Headquartered in Chicago, IL, we craft bespoke strategies and address today’s challenges. Partnering with Volto ensures your business gets the support it needs to design, build, and scale its products, systems, and processes.</p>
              </div>
            </Col>
          </Row>
         </Container>
      </div>
  )
}

export default PageDescription
